const bookShopEmail = (state = "", action) => {
    switch(action.type) {
        case 'bookShopEmail':
            return action.payload;
        default:
            return state;
    }
}

export default bookShopEmail;